module.exports = __webpack_public_path__ + "a406bd9a3403eccd2d0f954c0958413d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/gavel-s.png
// module id = 2036
// module chunks = 0